"use client";

import { Button } from "@/components/ui/button";
import { ArrowRight, X } from "lucide-react";
import Link from "next/link";
import { useEffect, useState } from "react";
export default function AnnouncementBanner() {
  const [isBannerVisible, setIsBannerVisible] = useState(false);
  useEffect(() => {
    const result = localStorage.getItem("isAnnouncementBannerVisible");
    setIsBannerVisible(result === "true" || result === null);
  }, []);
  function toggleBanner() {
    const newValue = !isBannerVisible;
    setIsBannerVisible(newValue);
    localStorage.setItem("isAnnouncementBannerVisible", String(newValue));
  }
  if (!isBannerVisible) {
    return null;
  }
  return <div className="flex w-full items-center justify-between bg-landingPageAccent px-4 py-2 text-sm text-slate-800" data-sentry-component="AnnouncementBanner" data-sentry-source-file="announcement-banner.tsx">
      <div />

      <Link href="#best-selling" className="group flex items-center justify-between gap-2" data-sentry-element="Link" data-sentry-source-file="announcement-banner.tsx">
        ✨
        <Button variant="link" className="h-fit p-0 text-slate-800" data-sentry-element="Button" data-sentry-source-file="announcement-banner.tsx">
          Get our best-selling course
          <ArrowRight size={16} className="ml-1 transform transition group-hover:translate-x-1" data-sentry-element="ArrowRight" data-sentry-source-file="announcement-banner.tsx" />
        </Button>
        ✨
      </Link>

      <div className="cursor-pointer" onClick={toggleBanner}>
        <X size={16} data-sentry-element="X" data-sentry-source-file="announcement-banner.tsx" />
      </div>
    </div>;
}